import apiClient from "../../../../http-common";
import authHeader from "../../../../authentication/authservices/auth-header";

//GetDietChartDetails
export const getDietChartDetails = () => {
  return apiClient.get(`/diticianModule/dietChartDetails`, {
    headers: authHeader(),
  });
};
